/**
 * Auth server
 * Auth server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum SmsConfirmationStatus {
    CONFIRMED = 'CONFIRMED',
    CODE_INVALID = 'CODE_INVALID',
    CODE_EXPIRED = 'CODE_EXPIRED',
    MAX_ATTEMPTS_EXCEEDED = 'MAX_ATTEMPTS_EXCEEDED'
}

